export function xIsNull(value)
{
    return value === null;
}
export function xIsUndefined(value)
{
    return value === undefined;
}
export function xIsSet(value)
{
    return value !== null && value !== undefined;
}
export function xIsArray(value)
{
    return value !== null && value !== undefined && value.constructor == Array;
}
export function xIsObject(value)
{
    return value !== null && value !== undefined && value.constructor == Object;
}
export function xIsObjectEmpty(value)
{
    return Object.keys(value).length === 0;
}
export function xIsFunction(value)
{
    return value !== null && value !== undefined && value.constructor == Function;
}
export function xIsDate(value)
{
    return value !== null && value !== undefined && value.constructor == Date;
}
export function xIsString(value)
{
    return value !== null && value !== undefined && value.constructor == String;
}
export function xIsNumber(value)
{
    return value !== null && value !== undefined && value.constructor == Number;
}
export function xIsInteger(value)
{
    return xIsNumber(value) && Number.isInteger(value);
}
export function xIsBoolean(value)
{
    return value !== null && value !== undefined && value.constructor == Boolean;
}
export function xIsSpecificClass(value, Class)
{
    return value !== null && value !== undefined && value.constructor == Class;
}
export function xIsAnySpecificClass(value, ...Classes)
{
    if(value === null || value === undefined)
    {
        return false;
    }
    for(const Class of Classes)
    {
        if(value.constructor == Class)
        {
            return true;
        }
    }
    return false;
}
